import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import Link from "../../../Link";
import SubMenuItem from "../SubMenuItem";

const RewardMenu = ({ isActive }) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      ...RewardsMenuIcons
    }
  `);

  return (
    <div
      id="sub-menu__campaigns"
      className={cx(
        "container sub-menu sub-menu__campaigns row",
        { active: isActive },
        { inactive: !isActive }
      )}
    >
      <div className="col mx-1 mx-xl-3 mt-5">
        <Link className="d-block" to={`/campaigns/`}>
          <h5>{t("menu.campaigns.content.title")}</h5>
          <span>{t("menu.campaigns.content.description")}</span>

          <p className="content-link mt-3">{t("common.viewAll")} &#8594;</p>
        </Link>
      </div>
      <div className="col mx-1 mx-xl-3 mt-4 px-2">
        <div className="row w-100">
          <SubMenuItem
            title={t("menu.campaigns.referAFriend.title")}
            description={t("menu.campaigns.referAFriend.description")}
            imageSrc={data.referAFriendIcon.publicURL}
            linkTo={`/earn-referral/`}
          />
        </div>
      </div>
      <div className="col-4 pl-0 mr-1 mx-xl-3 align-self-end">
        <StaticImage
          className="d-block"
          placeholder="none"
          src={"../../../../assets/images/menus/rewards.png"}
          alt="campaigns"
        />
      </div>
    </div>
  );
};

export default RewardMenu;
